/* eslint-disable no-underscore-dangle */
import { apiClient, handleResponse } from './axios';

async function addEvaluoExam(body) {
  try {
    const response = await apiClient.post('/evaluo/add-exam', body);
    const evaluoExam = await handleResponse(response);
    return evaluoExam;
  } catch (error) {
    return error.response;
  }
}

async function addStudentToEvaluoExam(examId, studentEmail) {
  try {
    const response = await apiClient.post(`/evaluo/add-student/${examId}/${studentEmail}`);
    const evaluoExam = await handleResponse(response);
    return evaluoExam;
  } catch (error) {
    return error.response;
  }
}

async function updateCompanyEvaluoStatus(companyId, activatedEvaluo) {
  try {
    const response = await apiClient.get(`/evaluo/company/${companyId}/${activatedEvaluo}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function updateEvaluoExam(examId, body) {
  try {
    const response = await apiClient.put(`/evaluo/exam/${examId}`, body);
    const evaluoExam = await handleResponse(response);
    return evaluoExam;
  } catch (error) {
    return error.response;
  }
}

async function deleteEvaluoExam(examId) {
  try {
    const response = await apiClient.delete(`/evaluo/exam/${examId}`);
    const evaluoExam = await handleResponse(response);
    return evaluoExam;
  } catch (error) {
    return error.response;
  }
}

async function deleteStudentFromEvaluoExam(examId, evaluoId) {
  try {
    const response = await apiClient.delete(`/evaluo/exam/delete-student/${examId}/${evaluoId}`);
    const evaluoExam = await handleResponse(response);
    return evaluoExam;
  } catch (error) {
    return error.response;
  }
}

async function getEvaluoExamsByCompany(companyId) {
  try {
    const response = await apiClient.get(`/evaluo/get-exams/${companyId}`);
    const evaluoExams = await handleResponse(response);
    return evaluoExams;
  } catch (error) {
    return error.response;
  }
}

async function getStudentsInExam(examId) {
  try {
    const response = await apiClient.get(`/evaluo/exam/students/${examId}`);
    const evaluoTestUsers = await handleResponse(response);
    return evaluoTestUsers;
  } catch (error) {
    return error.response;
  }
}

async function getSubjects() {
  try {
    const response = await apiClient.get('/evaluo/subjects');
    const evaluoSubjects = await handleResponse(response);
    return evaluoSubjects;
  } catch (error) {
    return error.response;
  }
}

const evaluoServices = {
  addEvaluoExam,
  addStudentToEvaluoExam,
  deleteEvaluoExam,
  deleteStudentFromEvaluoExam,
  getEvaluoExamsByCompany,
  getStudentsInExam,
  getSubjects,
  updateCompanyEvaluoStatus,
  updateEvaluoExam,
};

export default evaluoServices;
